import React from 'react'
import { Container } from 'react-bootstrap'
import CompLinkHeader from './compLinkHeader'
import Navbar from 'components/dashboard/navbar'
import Footer from 'components/dashboard/footer'
import './style.css'

export default function riwayat() {
    return (
        <Container className="component-riwayat">
            <Navbar />
             <CompLinkHeader to="/profile" back="Transaksi" title="
             Riwayat Pembayaran" />
            <Table />
            <Footer />
        </Container>
    )
}


function Table() {
    return (
        <Container className="table-riwayat">
            <table>
                <thead>
                    {Table_head.map(tab => {
                        return (
                            <th key={tab}>{tab.th}</th>
                        )
                    })}
                </thead>
                <tbody>
                    <tr>
                    {Table_head.map(tab => {
                        return (
                            <td key={tab}>{tab.td}</td>
                        )
                    })}
                    </tr>
                </tbody>
            </table>
        </Container>
    )
}

const Table_head = [
    {th:"Tanggal Awal Minggu", td:""},{th:"Pendapatan", td:""},{th:"Total Refund", td:""},{th:"Total Pembayaran", td:""},{th:"Komisi", td:""}
]
